import React, {useState} from 'react';
import {
    Box,
    Button,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Typography,
    Paper
} from '@mui/material';
import {useKeycloak} from "@react-keycloak/web";
import {ePismoClientInstance} from "../Service/EPismoClient";
import './ReportsView.scss';

const ReportsView = () => {
    const {keycloak} = useKeycloak();
    const currentYear = new Date().getFullYear();
    const [year, setYear] = useState<number | string>(currentYear);
    const [month, setMonth] = useState<number | string>("");

    const years = [];
    for (let i = currentYear; i >= 2024; i--) {
        years.push(i);
    }

    const months = [
        {value: 1, label: 'Styczeń'},
        {value: 2, label: 'Luty'},
        {value: 3, label: 'Marzec'},
        {value: 4, label: 'Kwiecień'},
        {value: 5, label: 'Maj'},
        {value: 6, label: 'Czerwiec'},
        {value: 7, label: 'Lipiec'},
        {value: 8, label: 'Sierpień'},
        {value: 9, label: 'Wrzesień'},
        {value: 10, label: 'Październik'},
        {value: 11, label: 'Listopad'},
        {value: 12, label: 'Grudzień'},
    ];

    const handleDownload = () => {
        if (!year) return;

        let endpoint = `/v1/logging/reports/messages?year=${year}`;
        if (month !== "") {
            endpoint += `&month=${month}`;
        }

        ePismoClientInstance.getFile(endpoint, keycloak)
            .then(response => {
                const contentDisposition = response.headers['content-disposition'];
                let filename = month === "" 
                    ? `raport_wiadomosci_${year}.pdf` 
                    : `raport_wiadomosci_${year}_${month.toString().padStart(2, '0')}.pdf`;
                
                if (contentDisposition) {
                    const filenameMatch = contentDisposition.match(/filename="?([^";]+)"?/);
                    if (filenameMatch && filenameMatch.length > 1) {
                        filename = filenameMatch[1];
                    }
                }

                const href = URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(href);
            })
            .catch(error => {
                console.error("Błąd podczas pobierania raportu:", error);
            });
    };

    return (
        <div className="ReportsView">
            <div className="container">
                <Typography variant="h1">Raporty</Typography>
                <Paper elevation={0}>
                    <Typography variant="h6" sx={{ mb: 3, color: '#0C324D', fontFamily: 'Inter', fontWeight: 600, textAlign: 'left'}}>
                        Raport korespondencji
                    </Typography>
                    <Grid container spacing={3} alignItems="flex-end">
                        <Grid item xs={12} sm={4}>
                            <FormControl fullWidth variant="outlined" size="small">
                                <InputLabel id="year-select-label">Rok</InputLabel>
                                <Select
                                    labelId="year-select-label"
                                    value={year}
                                    label="Rok"
                                    onChange={(e) => setYear(e.target.value)}
                                >
                                    {years.map(y => (
                                        <MenuItem key={y} value={y}>{y}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <FormControl fullWidth variant="outlined" size="small">
                                <InputLabel id="month-select-label">Miesiąc (opcjonalnie)</InputLabel>
                                <Select
                                    labelId="month-select-label"
                                    value={month}
                                    label="Miesiąc (opcjonalnie)"
                                    onChange={(e) => setMonth(e.target.value)}
                                >
                                    <MenuItem value="" sx={{ display: 'none' }}>Cały rok</MenuItem>
                                    {months.map(m => (
                                        <MenuItem key={m.value} value={m.value}>{m.label}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Button
                                variant="contained"
                                className="downloadButton"
                                fullWidth
                                size="large"
                                onClick={handleDownload}
                                disabled={!year}
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    height: '40px'
                                }}
                            >
                                Pobierz raport PDF
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>
            </div>
        </div>
    );
};

export default ReportsView;
